import { reactive, ref } from 'vue';
import { defineStore } from 'pinia';
import { baseMixins } from '@common/mixins/baseMixins';
import { isFusionBankApp } from '@tencent/vb-web-base-core';
import { IProductViewData } from '../core/interface/IModel';
import { getProductConfigs } from '@common/core/network/NodeAPI';
import { IProductConfItem } from '@loan/vb-node-loan/types';
interface IProductStoreItem extends IProductConfItem {
  lang: string
}
const productConfig = reactive<IProductStoreItem>({
  mainTitle: '',
  // subTitle: '',
  codeTitle: '',
  codeSubTitle: '',
  actCode: '',
  actCodeProof: [] as Array<{ code: string; text: string; protoKey: string }>,
  allowNoReside: '',
  proto: '',
  loanTargets: [] as Array<{ id: string; value: string }>,
  applyTips: '',
  applyText: '',
  remark: '',
  increaseWhiteList: '',
  increaseLimitText: '',
  lang: '',
  backGroundPic: "",
  footerNotes: [],
  loanIndexTab: [],
  productNo: "",
  approvalText: "",
  approvalLink: "",
  proofOperationTips: { addressProofTips: '', incomeProofTipsSummary: '', incomeProofTips: '', assetProofTips: '' },
  activityNote: [],
  mainGroundPic: '',
  dayRate: '',
  apr: ''
});

export const useProductConfigs = defineStore(
  'useProductConfigs',
  () => {
    const { getBaseParam, getLanguage } = baseMixins();
    const config = reactive(productConfig);
    const ready = ref(false);
    const initConfig = async () => {
      // 切换了语言也要重新获取 不然可能因为sessionstoreyge缓存 还是老的语言文案
      if (ready.value && productConfig.lang == getLanguage()) {
        return;
      }
      const configs = await getProductConfigs({
        productNo: getBaseParam('prodNo'),
        source: isFusionBankApp ? 'app' : 'wallet',
      });

      configs.mainTitle = configs.mainTitle.replace(/\\n/gm, '\n');
      // configs.subTitle = configs.subTitle.replace(/\\n/gm, '\n');
      productConfig.lang = getLanguage();
      Object.assign(productConfig, configs);
      ready.value = true;
    };
    return {
      initConfig,
      ready,
      config,
    };
  },
  {
    // @ts-ignore
    persist: true,
  },
);
